import { Injectable } from '@angular/core';
import { AuthenticationService } from "../authentication.service";
import {
    Http,
    Headers,
    RequestOptions,
    Response,
    URLSearchParams
} from "@angular/http";


@Injectable()
export class InposService {

    constructor(private auth: AuthenticationService, private http: Http) { }

    //--------------Counter-----------------//
    getCounter(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_Counter",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    getCounterById(Body: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_CounterById",
                Body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    saveCounter(Counter: any) {
        if (Counter.Id == 0) {
            return this.http
                .post(
                    this.auth.baseUrl + "/services/api/v1/Save_Counter",
                    Counter,
                    this.auth.getHeader()
                )
                .map(res => {
                    return res.json();
                });
        } else {
            return this.http
                .put(
                    this.auth.baseUrl + "/services/api/v1/Update_Counter",
                    Counter,
                    this.auth.getHeader()
                )
                .map(res => {
                    return res.json();
                });
        }
    }
    deleteCounter(Body: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_Counter",
                Body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //--------------Counter-----------------//
    //--------------Cashier-----------------//
    getCashier(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_Cashier",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    getCashierById(Body: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_CashierById",
                Body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    saveCashier(Cashier: any) {
        if (Cashier.Id == 0) {
            return this.http
                .post(
                    this.auth.baseUrl + "/services/api/v1/Save_Cashier",
                    Cashier,
                    this.auth.getHeader()
                )
                .map(res => {
                    return res.json();
                });
        } else {
            return this.http
                .put(
                    this.auth.baseUrl + "/services/api/v1/Update_Cashier",
                    Cashier,
                    this.auth.getHeader()
                )
                .map(res => {
                    return res.json();
                });
        }
    }
    deleteCashier(Cashier: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_Cashier",
                Cashier,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });

    }
    //--------------Cashier-----------------//

    //--------------privilege-----------------//
    getPosPrivilegeByUserId(Body: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PosPrivilege_ByUserId",
                Body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    saveUserRights(Cashier: any) {

        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_PosPrivilege",
                Cashier,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    //--------------privilege-----------------//
    //--------------DateChange-----------------//
    getDateChange(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_Datechange",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    getClosingDate(LocationId: number) {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_ClosingDate?LocationId=" + LocationId,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    getMaxDate(LocationId: number) {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_MaxDate?LocationId=" + LocationId,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    getOpeningDate(LocationId: number) {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_openingDate?LocationId=" + LocationId,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    saveDatechange(Datechange: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_DateChange",
                Datechange,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------DateChange------------------//
    //-----------------Predefined Promotion------------------//
    getPrdefinedPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/POS/Get_AllPOS_PredefinedDiscount_Backoffice",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    savePredefinedPromotion(FilterItems: any) {
        if (FilterItems.Id == 0) {
            return this.http
                .post(
                    this.auth.baseUrl + "/services/api/v1/POS/Save_Pos_PreDiscount",
                    FilterItems,
                    this.auth.getHeader()
                )
                .map(res => {
                    return res.json();
                });
        }
        else {
            return this.http
                .post(
                    this.auth.baseUrl + "/services/api/v1/POS/Update_Pos_PreDiscount",
                    FilterItems,
                    this.auth.getHeader()
                )
                .map(res => {
                    return res.json();
                });
        }
    }
    deletePrdefinedPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/POS/Delete_PrdedinedPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PreDiscount_Department_ByLevelNo(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/POS/Get_PreDiscount_Department_ByLevelNo",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------Predefined Promotion------------------//
    //-----------------BuyXgetY Promotion------------------//
    Get_BuyxGetYPromotionList(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_BuyxGetYPromotionList",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_BuyxGetYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_BuyxGetYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PromotionStatus() {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_PromotionStatus",
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_BuyxGetYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_BuyxGetYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_BuyxGetYPromotionById(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_BuyxGetYPromotionById",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_BuyxGetYPromotionMaster(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_BuyxGetYPromotionMaster",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_BuyxGetYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_BuyxGetYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Update_BuyxGetYPromotionPriority(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Update_BuyxGetYPromotionPriority",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Validate_DeleteBuyxGetYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Validate_DeleteBuyxGetYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------BuyXgetY Promotion------------------//
    //-----------------MforXNforY Promotion------------------//
    Save_MforXNforYPromotionMaster(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_MforXNforYPromotionMaster",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Update_MforXNforYPromotionMaster(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Update_MforXNforYPromotionMaster",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_MforXNforYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_MforXNforYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    Get_MforXNForYPromotionMasterList() {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_MforXNForYPromotionMasterList",
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_MforXNForYPromotionList(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_MforXNForYPromotionList",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_MforXNForYPromotionDetailsById(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_MforXNForYPromotionDetailsById",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Update_MforXNforYpromotionPriority(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Update_MforXNforYpromotionPriority",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_MforXNforYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_MforXNforYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Validate_RunningMforXNforYPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Validate_RunningMforXNforYPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_MforXNforYPromotionPriority() {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_MforXNforYPromotionPriority",
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------MforXNforY Promotion------------------//
    //-----------------Item Promotion------------------//
    Get_ItemPromotionList(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_ItemPromotionList",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_ItemPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_ItemPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_ItemPromotionDetails(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_ItemPromotionDetails",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_ItemPromotionById(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_ItemPromotionById",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_ItemPromotionMaster(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_ItemPromotionMaster",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_ItemPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_ItemPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Update_ItemPromotionPriority(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Update_ItemPromotionPriority",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Validate_DeleteItemPromotion(FilterItems: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Validate_DeleteItemPromotion",
                FilterItems,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------Item Promotion------------------//
    //-----------------Denomination------------------//
    Save_POSDenomination(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_POSDenomination",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PosDenominationByCurrency(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PosDenominationByCurrency",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_CurrencyForDenomination(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_CurrencyForDenomination",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_IdForPosDenomination() {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_IdForPosDenomination",
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_POSDenomination(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_POSDenomination",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Update_POSDenomination(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Update_POSDenomination",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------Denomination------------------//
    //-----------------Currency------------------//
    Save_PosCurrencyMaster(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_PosCurrencyMaster",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PosCurrencyMaster(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PosCurrencyMaster",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_PosCurrencyMaster(model: any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_PosCurrencyMaster",
                model,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_IdForPosCurrency() {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Get_IdForPosCurrency",
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    //-----------------Currency------------------//
     //-----------------GiftCard------------------//
     Get_POSGiftcard(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_POSGiftcard",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_GiftCardByCardNo(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_GiftCardByCardNo",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_POSGiftCardById(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_POSGiftCardById",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    SaveUpdate_POSGiftCard(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/SaveUpdate_POSGiftCard",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_POSGiftcard(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_POSGiftcard",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Generate_POSGiftCardNo() {
        return this.http
            .get(
                this.auth.baseUrl + "/services/api/v1/Generate_POSGiftCardNo",
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    
      //-----------------GiftCard------------------//

      //------------------OnlinePaymenyProvider---------//
      Save_OnlinePaymentProvider(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_OnlinePaymentProvider",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PaymentTypeForOnlinePaymentProvider(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PaymentTypeForOnlinePaymentProvider",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_OnlinePaymentProvider(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_OnlinePaymentProvider",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_OnlinePaymentProvider(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_OnlinePaymentProvider",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
      //------------------OnlinePaymenyProvider---------//
      //--------------------other cards-------------------//
      Get_PosOtherCardsList(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PosOtherCardsList",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PosOtherCardById(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PosOtherCardById",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_OtherCard(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_OtherCard",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_OtherCard(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_OtherCard",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
      //--------------------other cards-------------------//
    //--------------------Dept Gift Voucher Settings-------//
    Get_PDeptGiftVoucherSettingsList(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PDeptGiftVoucherSettingsList",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Get_PDeptGiftVoucherSettingsId(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Get_PDeptGiftVoucherSettingsId",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Save_PDeptGiftVoucherSettings(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Save_PDeptGiftVoucherSettings",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }
    Delete_PDeptGiftVoucherSettings(body:any) {
        return this.http
            .post(
                this.auth.baseUrl + "/services/api/v1/Delete_PDeptGiftVoucherSettings",body,
                this.auth.getHeader()
            )
            .map(res => {
                return res.json();
            });
    }

    //--------------------Dept Gift Voucher Settings-------//

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-pos.service.ts